export const notifications = [];
